export const notifications = [];
